import { useInfiniteQuery } from "@tanstack/react-query";

import { chatApi } from "@/features/messaging/services/chat.api";

/**
 * Page 1 is the *newest* N messages (server sorts `createdAt` descending —
 * server/src/repositories/message.repository.ts), each subsequent page
 * progressively older — the standard shape for "load older messages on
 * scroll up." `ChatConversationPage` flattens+reverses pages for display
 * (oldest at top) and keeps newly-arrived live messages in separate local
 * state rather than splicing them into this cache, since page 1 being
 * "newest" makes appending a *new* newest message to the *paginated* cache
 * more error-prone than it's worth for a chat thread's actual needs.
 */
export function useMessages(chatId: string) {
  return useInfiniteQuery({
    queryKey: ["messages", chatId],
    queryFn: ({ pageParam }) => chatApi.getMessages(chatId, pageParam),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.meta.page < lastPage.meta.totalPages ? lastPage.meta.page + 1 : undefined,
    enabled: Boolean(chatId),
  });
}
